import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

export const firebaseConfig = {
  apiKey: "AIzaSyAUqqFAS9cKK0Cp3celFc8tTxPnn9PiutE",
  authDomain: "next-ffca0.firebaseapp.com",
  projectId: "next-ffca0",
  storageBucket: "next-ffca0.firebasestorage.app",
  messagingSenderId: "780721368727",
  appId: "1:780721368727:web:ee41bcbd14d740de0843d2",
  measurementId: "G-R6X2EMV9DX"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app)
export const functions = getFunctions(app);